export enum PouchContentType {
  activity = 'sport',
  alert = 'alert',
  attack = 'attack',
  anamnesis = 'anamnese',
  completedAction = 'completedAction',
  completedHubNoteComment = 'completedHubNoteComment',
  config = 'config',
  confirm = 'confirm',
  dailyGlucose = 'dailyGlucose',
  device = 'device',
  evaluation = 'evaluation',
  event = 'event',
  feeling = 'feeling',
  fhir = 'fhir',
  generali = 'generali',
  glucose = 'glucose',
  glucosePeak = 'glucosePeak',
  guide = 'guide',
  guideRun = 'guideRun',
  guideRunConditionStatus = 'guideRunConditionStatus',
  health = 'health',
  lecture = 'lecture',
  localChallenge = 'localChallenge',
  localGuide = 'localGuide',
  meal = 'meal',
  medication = 'medication',
  medicationActiveIngredients = 'medicationActiveIngredients',
  menstruation = 'menstruation',
  microbiome = 'microbiome',
  questionnaire = 'questionnaire',
  replacementSensorOrder = 'replacementSensorOrder',
  report = 'report',
  sensor = 'sensor',
  sleep = 'sleep',
  status = 'status',
  update = 'updates',
  user = 'user',
  water = 'water',
  weight = 'weight',
  schedule = 'schedule',
  step = 'step',
  stepGoal = 'stepGoal',
  calorieBudget = 'calorieBudget',
  goalDefinition = 'goalDefinition',
  goalCompletion = 'goalCompletion',
  hubNotes = 'hubNotes',
  preferences = 'preferences',
  knowledgeBit = 'knowledgeBit',
  contentTracking = 'contentTracking',
}
